import { useRef } from "react";
import { matchPrefix } from "./optionNavigation";
import type { SelectOption } from "./selectOption";

/** A key typed within this time of the previous one extends the prefix instead of starting a new one. */
export const TYPEAHEAD_RESET_MS = 600;

export interface TypedPrefix {
  text: string;
  /** When the last key was typed (ms). */
  at: number;
}

/** The prefix after typing `key` at `now`. */
export function appendTyped(typed: TypedPrefix, key: string, now: number): TypedPrefix {
  const text = now - typed.at > TYPEAHEAD_RESET_MS ? key : typed.text + key;
  return { text, at: now };
}

/** A printable character typed without Ctrl, Cmd or Alt. */
export function isTypeaheadKey(e: Pick<KeyboardEvent, "key" | "ctrlKey" | "metaKey" | "altKey">): boolean {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
}

/** Returns a matcher that adds a key to the typed prefix and finds the next option starting with it (-1 if none). */
export function useTypeahead(): (key: string, options: SelectOption[], from: number) => number {
  const typed = useRef<TypedPrefix>({ text: "", at: 0 });
  return (key, options, from) => {
    typed.current = appendTyped(typed.current, key, Date.now());
    return matchPrefix(options, from, typed.current.text);
  };
}
